// - Headers Table SalarySettlement of Payroll
import moment from 'moment'
export default [
    {
        text: 'Fecha D/H',
        fieldType: 'computed',
        computed: ({ debit_accounting_date, credit_accounting_date }) => {
            return (
                moment(debit_accounting_date).format('DD-MM-YYYY') +
                ' / ' +
                moment(credit_accounting_date).format('DD-MM-YYYY')
            )
        },
    },
    {
        text: 'Asiento D/H',
        fieldType: 'computed',
        computed: ({ debit_code, credit_code }) => {
            return debit_code + ' / ' + credit_code
        },
    },
    {
        text: 'Deber',
        fieldType: 'computed',
        computed: ({ debit }) => {
            return debit
        },
        format: 'currency',
    },
    {
        text: 'Haber',
        fieldType: 'computed',
        computed: ({ credit }) => {
            return credit
        },
        format: 'currency',
    },
]
